export const JASON_ADMIN_EMAIL = 'jason@intellerview.com';

export const isJasonAdminEmail = (email?: string | null): boolean =>
  (email || '').trim().toLowerCase() === JASON_ADMIN_EMAIL;
